"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("@emotion/native"));
var Touchable = native_1.default.TouchableOpacity({
    backgroundColor: 'transparent',
    position: 'absolute',
    right: 8,
    bottom: 12,
    zIndex: 100,
});
var HideIcon = native_1.default.Text(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 14,
        color: theme.buttonTextColor,
    });
});
var VisibilityButton = /** @class */ (function (_super) {
    __extends(VisibilityButton, _super);
    function VisibilityButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisibilityButton.prototype.render = function () {
        var onPress = this.props.onPress;
        return (react_1.default.createElement(Touchable, { onPress: onPress, testID: "Storybook.OnDeviceUI.toggleUI", accessibilityLabel: "Storybook.OnDeviceUI.toggleUI", hitSlop: { top: 5, left: 5, bottom: 5, right: 5 } },
            react_1.default.createElement(HideIcon, null, "\u25A1")));
    };
    return VisibilityButton;
}(react_1.PureComponent));
exports.default = VisibilityButton;
